import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom';
import { Paper, Box, Typography, Divider, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckMenuList from '../../components/usermenumng/CheckMenuList'
import { menus } from '../../components/common/drawer/menu'
import _ from 'lodash';

const WhiteIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.background.paper,
    '&:hover': {
        backgroundColor: theme.palette.getContrastText(theme.palette.background.paper),
    },
}));

const UserMenuListContainer = ({ user }) => {
    let navigate = useNavigate();
    const handleGoBack = () => {
        navigate('/usermenumng')
    }

    const [allMenuIds, setAllMenuIds] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [checkedMenuItems, setCheckedMenuItems] = useState([]);


    const handleAllToggle = (event) => {
        //console.log(event.target.checked,'all');
        if (event.target.checked) {
            setCheckedMenuItems(allMenuIds);
        } else {
            setCheckedMenuItems([]);
        }
        setAllChecked(event.target.checked);

    }

    useEffect(() => {
        let checkedItem = [];
        let allMenuId = [];
        _.forEach(menus, (menu) => {
            if (menu.items) {
                _.forEach(menu.items, (item) => {
                    if (item.checked) {
                        checkedItem.push(item.id);
                    }
                    allMenuId.push(item.id);
                })
            }
            setCheckedMenuItems(checkedItem);
            setAllMenuIds(allMenuId);
        })
    }, [])

    const handleParentChange = (event, childIds) => {
        if (event.target.checked) {
            setCheckedMenuItems(_.union(checkedMenuItems, childIds));
        } else {
            setCheckedMenuItems(_.filter(checkedMenuItems, (item) => !childIds.includes(item)));
        }
    }

    const handleCheckboxChange = (event, id) => {
        //const id = event.target.id;
        // console.log(id, 'id');
        setCheckedMenuItems((chekedMenu) =>
            chekedMenu.includes(id)
                ? checkedMenuItems.filter((f) => f !== id)
                : [...checkedMenuItems, id],
        );
    };


    const handleSave = () => {

        const dataToSubmit = {
            usrUuid: user?.usrUuid,
            menus: checkedMenuItems.toString()
        }
        console.log(JSON.stringify(dataToSubmit));
    }

    return (
        <Paper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: '#424242',
                    color: '#fff',
                    py: 1,
                    px: 2
                }}
            >
                <Box sx={{ mr: 1 }}>
                    <WhiteIconButton size="small" onClick={handleGoBack}>
                        <ArrowBackIcon aria-label="goBack" />
                    </WhiteIconButton>
                </Box>
                <Typography variant="subtitle2" component="div">
                    {user?.usrNm} {user?.gradeNm} ({user?.dptNm}) 메뉴 리스트
                </Typography>
            </Box>
            <Divider />
            <CheckMenuList
                menus={menus}
                allChecked={allChecked}
                handleAllToggle={handleAllToggle}
                handleParentChange={handleParentChange}
                checkedMenuItems={checkedMenuItems}
                handleCheckboxChange={handleCheckboxChange}
                handleSave={handleSave} />
        </Paper>
    )
}

export default UserMenuListContainer